import _ from "lodash";
import React from "react";

export default function InputPhoneNumber({
   type,
   phoneNumber,
   setPhoneNumber,
   validation,
}) {
   const handleChange = (e) => {
      const inputValue = e.target.value;

      // Hanya izinkan angka
      const numericValue = inputValue.replace(/\D/g, "");

      // Jika karakter pertama adalah "0", ganti menjadi "62"
      const formattedValue = numericValue.startsWith("0")
         ? `62${numericValue.slice(1)}`
         : numericValue;

      // Jika input tidak dimulai dengan "62", tambahkan "62" pada awal
      const finalValue = !formattedValue.startsWith("62")
         ? `62${formattedValue}`
         : formattedValue;

      setPhoneNumber((prevState) => ({
         ...prevState,
         [type]: finalValue,
      }));
   };

   return (
      <>
         <div className="relative">
            <input
               name="user_mobile"
               className={`form-input w-full pl-6 h-12 ${
                  !validation.phone.validate && "border-rose-500"
               }`}
               type="tel"
               value={phoneNumber ?? ""}
               onChange={(e) => handleChange(e)}
            />
            <div className="absolute inset-0 right-auto flex items-center pointer-es-none">
               <span className="text-sm text-gray-400 font-medium px-3">+</span>
            </div>
         </div>
         {!validation.phone.validate ? (
            <div className="text-xs text-rose-500">
               {validation.phone.message}
            </div>
         ) : (
            <></>
         )}
      </>
   );
}
